module.exports = __webpack_public_path__ + "img/ercode_anhui.227d590b.png";